import React, { Component } from "react";
import {
  CardTitle,
  Card,
  CardHeader,
  ButtonGroup,
  Button,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import { ZoneService } from "../../services/zoneService";
import { Link } from "react-router-dom";
import { reloadZones } from "../../redux/actions/index";
import { connect } from "react-redux";
import { Search } from "../../containers";
import { CompanyService } from "../../services/companyService";
import { ModalDelete } from "../../containers";
import SearchInput, { createFilter } from "react-search-input";
import PropTypes from "prop-types";
import { ChannelService } from "../../services/channelService";
import { BrandService } from "../../services/brandService";
const KEYS_TO_FILTERS = ["place", "manager", "email"];

let zoneService = new ZoneService();
let companyService = new CompanyService();
let channelService = new ChannelService();
let brandService = new BrandService();

class TableHead extends Component {
  render() {
    return (
      <thead>
        <tr>
          <th>Zona</th>
          <th>Marca</th>
          {this.props.viewButton && <th>Cliente</th>}
          <th>Canal</th>
          <th>Key</th>
          <th>Acción</th>
        </tr>
      </thead>
    );
  }
}

class Zone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false,
      show: false
    };
    this.toogleDelete = this.toogleDelete.bind(this);
    this.toogleShow = this.toogleShow.bind(this);
    this.sendDelete = this.sendDelete.bind(this);
  }
  toogleDelete() {
    this.setState({
      deleting: !this.state.deleting
    });
  }
  toogleShow() {
    this.setState({
      show: !this.state.show
    });
  }
  sendDelete() {
    let self = this;
    zoneService.deleteById(this.props.item.id).then(function(data) {
      zoneService.reload();
      self.context.getNotificationSystem().addNotification({
        message:
          "Se ha eliminado exitosamente la Zona: " + self.props.item.name + ".",
        title: "Zona Eliminada",
        level: "success"
      });
      self.toogleDelete();
    });
  }
  render() {
    let deleting = this.state.deleting;
    let show = this.state.show;
    let item = this.props.item;
    let brand = brandService.Match(item.brandId);
    let key = brand ? brand.key + "-" + item.tag : "XXXX-XXXX-" + item.tag;
    return (
      <tr>
        <td>{item.name}</td>
        <td>{brandService.MatchName(item.brandId)}</td>
        {this.props.viewButton && (
          <td>{companyService.MatchName(item.companyId)}</td>
        )}
        <td>{channelService.MatchName(item.channelId)}</td>
        <td>
          {show ? key : "*".repeat(14)}
          <Button
            onClick={this.toogleShow}
            className="btn btn-warning btn-sm pull-right ml-2"
          >
            {show ? "Ocultar" : "Mostrar"}
          </Button>
        </td>
        <td className="text-center">
          <ButtonGroup className="mr-3" aria-label="First group">
            {this.props.viewButton && (
              <Button
                onClick={this.toogleDelete}
                className="btn btn-danger btn-sm"
              >
                <i className="fa fa-trash" />
                {deleting && (
                  <ModalDelete
                    show={deleting}
                    close={this.toogleDelete}
                    sendDelete={this.sendDelete}
                    name={item.name + " y todas sus tiendas asociadas"}
                    entityName="un Zona"
                  />
                )}
              </Button>
            )}

            <Link
              to={"/zones/edit/" + item.id}
              className="btn btn-primary btn-sm"
            >
              <i className="fa fa-edit" />
            </Link>
          </ButtonGroup>
        </td>
      </tr>
    );
  }
}

Zone.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

class ZoneConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      searchTerm: ""
    };
    channelService.reload();
    companyService.reload();
    brandService.reload();
    this.mounted = true;
    this.loadData(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  searchUpdated(term) {
    this.setState({ searchTerm: term });
  }
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }
  loadData(self) {
    zoneService
      .read()
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          self.props.reloadZones(data);
        }
        if (self.mounted)
          self.setState({
            loading: false
          });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  render() {
    let { data, user } = this.props;
    let company = this.state.company;
    let filtered = data;
    if (company) {
      filtered = filtered.filter(x => company === x.companyId);
    }
    filtered = filtered.filter(
      createFilter(this.state.searchTerm, KEYS_TO_FILTERS)
    );
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <div className="d-sm-flex w-100 justify-content-between">
              <CardTitle className="mb-0">Zonas</CardTitle>
              {user.role === "ADMIN" && (
                <h6 className="mb-1">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>Compañia</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      id="company"
                      value={company}
                      onChange={this.handleChange}
                    >
                      <option value="">Cualquier Compañia</option>
                      {this.props.companies.map((e, i) => {
                        return (
                          <option key={i} value={e.id}>
                            {e.name}
                          </option>
                        );
                      })}
                    </Input>
                  </InputGroup>
                </h6>
              )}
              <h6 className="mb-1 col-sm-5">
                <SearchInput
                  className="search-input input-group"
                  inputClassName="form-control"
                  placeholder="Buscar..."
                  onChange={this.searchUpdated}
                />
              </h6>
              {user.role === "ADMIN" && (
                <h6 className="mb-1">
                  <div className="card-header-actions">
                    <Link
                      to={"/zones/create"}
                      className="btn btn-default btn-sm float-right"
                    >
                      Agregar Zona <i className="fa fa-plus" />
                    </Link>
                  </div>
                </h6>
              )}
            </div>
          </CardHeader>
          <Search
            table={true}
            Thead={TableHead}
            data={filtered}
            ObjectTemplate={Zone}
            loading={this.state.loading}
            bordered={false}
            striped={false}
            viewButton={user.role === "ADMIN"}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.zones,
    companies: state.companies,
    user: state.user,
    channels: state.channels
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reloadZones: zones => dispatch(reloadZones(zones))
  };
};

const Zones = connect(
  mapStateToProps,
  mapDispatchToProps
)(ZoneConnector);

export default Zones;
